import React, { useCallback, useEffect } from "react";
import {
  Card,
  Input,
  Headline,
  InputLabel,
  Flex,
  Paragraph,
  Checkbox,
} from "_styleguide";
import Footer from "../_components/Footer/Footer";
import { useLead } from "_contexts/useLead";
import { useSettings } from "_contexts/useSettings";
import { validateEmailForm } from "./_helpers";
import { useRecaptcha } from "_hooks/useRecaptcha";
import "./Email.scss";

function Email(props) {
  const { lead, updateLead } = useLead();
  const { settings: globalSettings } = useSettings();
  const settings = props.settings?.settings;
  const primaryColor = globalSettings?.primary_color || "#0f766e";

  // Initialize reCAPTCHA if captcha is enabled for email page
  const captchaEnabled = settings?.captcha === true;
  const { executeRecaptcha, isLoading: recaptchaLoading } =
    useRecaptcha(captchaEnabled);

  const validation = validateEmailForm(lead);
  const optInEnabled = settings?.opt_in === true;

  useEffect(() => {
    if (optInEnabled && lead.email_opt_in == null) {
      updateLead("email_opt_in", true);
    }
  }, [optInEnabled]);

  // Function to get recaptcha token - passed to Footer
  const getRecaptchaToken = useCallback(async () => {
    if (!captchaEnabled) return null;
    return await executeRecaptcha("email_submit");
  }, [captchaEnabled, executeRecaptcha]);

  return (
    <Card id="email">
      <div className="apply-form">
        <Headline>{settings.title}</Headline>
        {settings?.subtitle ? (
          <Paragraph
            opacity={0.6}
            align="left"
            size="14px"
            dangerouslySetInnerHTML={{
              __html: settings?.subtitle,
            }}
          />
        ) : null}
        <Flex vertical style={{ marginTop: settings?.subtitle ? "0" : "24px" }}>
          <InputLabel htmlFor="email" {...validation.email}>
            Email:
          </InputLabel>
          <Input
            id="email"
            value={lead.email}
            onChange={(e) => updateLead("email", e.target.value)}
            size="medium"
            placeholder="e.g. franklin@gmail.com"
            autoFocus
            {...validation.email}
          />
        </Flex>
        {optInEnabled ? (
          <Flex
            vertical
            style={{ marginTop: "16px", "--link-color": primaryColor }}
            className="email-opt-in"
          >
            <Checkbox
              checked={lead.email_opt_in !== false}
              onChange={(e) => updateLead("email_opt_in", e.target.checked)}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: settings?.opt_in_text,
                }}
              />
            </Checkbox>
          </Flex>
        ) : null}
      </div>
      <Footer
        next={props.settings.next}
        settings={props.settings}
        disableNext={!validation.allValid || recaptchaLoading}
        getRecaptchaToken={captchaEnabled ? getRecaptchaToken : undefined}
      />
    </Card>
  );
}

export default Email;
